/**
 * Created by hanyong.zheng on 2018/12/26.
 */
import { addRepair, checkRepair, getBreakDeviceType, getBreakType, getRepairList, getRepairInfo, getServerModel } from '@/api/repair'

const repair = {
  state: {
    repairList: []
  },
  mutations: {
    SET_REPAIRLIST: (state, repairList) => {
      state.repairList.length = 0
      if (repairList.length !== 0) {
        repairList.map(function (item) {
          state.repairList.push(item)
        })
      }
    }
  },
  actions: {
    // 新增保修单
    AddRepair ({ commit }, object) {
      return new Promise((resolve, reject) => {
        addRepair(object).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 判断保修单是否重复
    CheckRepair ({ commit }, object) {
      return new Promise((resolve, reject) => {
        checkRepair(object).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取故障设备下拉内容
    GetBreakDeviceType({commit}, object) {
      return new Promise((resolve, reject) => {
        getBreakDeviceType(object).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取故障类型下拉内容
    GetBreakType({commit}, object) {
      return new Promise((resolve, reject)  => {
        getBreakType(object).then(response =>{
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetRepairList ({ commit }, userId) {
      return new Promise((resolve, reject) => {
        getRepairList(userId).then(response => {
          const data = response.data
          if (data.code === '0') {
            commit('SET_REPAIRLIST', data.data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRepairInfo ({ commit }, repairParams) {
      return new Promise((resolve, reject) => {
        getRepairInfo(repairParams).then(response => {
          const data = response.data
          if (data.code === '0') {
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getServerModel ({ commit }, deviceSeq) {
      return new Promise((resolve, reject) => {
        getServerModel(deviceSeq).then(response => {
          const data = response.data
          if (data.code === '0') {
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default repair



// WEBPACK FOOTER //
// ./src/store/modules/repair.js